import {
    WORKERS_LOADING,
    WORKERS_ERROR,

    WORKERS_GET_LIST,
    WORKERS_GET_BY_ID,
    WORKERS_UPDATE_BY_ID,

    WORKERS_GET_PAYRATE_OVERRIDES,
    WORKERS_GET_PAYRATE_OVERRIDE_SINGLE,
    WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE,
    WORKERS_DELETE_PAYRATE_OVERRIDE_SINGLE,

    WORKERS_GET_COMMENTS,
    WORKERS_GET_COMMENT_SINGLE,
    WORKERS_UPDATE_COMMENT_SINGLE,
    WORKERS_DELETE_COMMENT_SINGLE,
} from "api/menu/master-files/workers-maintenance/actions";

const initialState = {
    loading: false,
    errors: [],

    workersList: [],
    workersSingle: {},

    payRateOverrides: [],
    payRateOverridesSingle: {},

    comments: [],
    commentSingle: {}
};

export default function(state = initialState, action) {
    let payRateOverrides,
        comments,
        index;
    switch (action.type) {
        case WORKERS_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case WORKERS_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };

        case WORKERS_GET_LIST:
            return {
                ...state,
                loading: false,
                workersList: action.payload
            };
        case WORKERS_GET_BY_ID:
            return {
                ...state,
                loading: false,
                workersSingle: action.payload
            };
        case WORKERS_UPDATE_BY_ID:
            return {
                ...state,
                loading: false,
            };
        case WORKERS_GET_PAYRATE_OVERRIDES:
            return {
                ...state,
                loading: false,
                payRateOverrides: action.payload,
            };
        case WORKERS_GET_PAYRATE_OVERRIDE_SINGLE:
            return {
                ...state,
                loading: false,
                payRateOverridesSingle: action.payload,
            };
        case WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE:
            payRateOverrides = Object.assign([], state.payRateOverrides);
            index = payRateOverrides
                .findIndex(item => item.payRateOverrideID === action.payload.payRateOverrideID);
            if (index > -1) {
                payRateOverrides[index] = action.payload;
            } else {
                payRateOverrides.unshift(action.payload);
            }
            return {
                ...state,
                loading: false,
                payRateOverrides,
                payRateOverridesSingle: {}
            };
        case WORKERS_DELETE_PAYRATE_OVERRIDE_SINGLE:
            payRateOverrides = Object.assign([], state.payRateOverrides);
            index = payRateOverrides
                .findIndex(item => item.payRateOverrideID === action.payload);
            if (index > -1) {
                payRateOverrides.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                payRateOverrides,
            };
        case WORKERS_GET_COMMENTS:
            return {
                ...state,
                loading: false,
                comments: action.payload
            };
        case WORKERS_GET_COMMENT_SINGLE:
            return {
                ...state,
                loading: false,
                commentSingle: action.payload
            };
        case WORKERS_UPDATE_COMMENT_SINGLE:
            comments = Object.assign([], state.comments);
            index = comments
                .findIndex(item => item.id === action.payload.id);
            if (index > -1) {
                comments[index] = action.payload;
            } else {
                comments.unshift(action.payload);
            }
            return {
                ...state,
                loading: false,
                comments
            };
        case WORKERS_DELETE_COMMENT_SINGLE:
            comments = Object.assign([], state.comments);
            index = comments
                .findIndex(item => item.id === action.payload);
            if (index > -1) {
                comments.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                comments
            };
        default:
            return state;
    }
}
